/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerRemoveMutationResponse, TasksControllerRemovePathParams, TasksControllerRemove401, TasksControllerRemove403, TasksControllerRemove404 } from "../../models/tasksController/TasksControllerRemove";

function getTasksControllerRemoveUrl(id: TasksControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/tasks/${id}` as const }  
  return res
}

/**
 * @summary Soft-delete a task
 * {@link /api/v1/tasks/:id}
 */
export async function tasksControllerRemove(id: TasksControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TasksControllerRemoveMutationResponse, ResponseErrorConfig<TasksControllerRemove401 | TasksControllerRemove403 | TasksControllerRemove404>, unknown>({ method : "DELETE", url : getTasksControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}